import React from 'react';
import 'chart.js/auto';
import { PolarArea } from 'react-chartjs-2'
import { Chart, Title } from "chart.js";

const PolarAreaChart = (props) => {
    Chart.register(Title);

    return (
        <div>
            <PolarArea key={props.key} data={props.chartData}
                height={props.height}
                width={props.width}
                options={props.options}
            />
        </div>
    );
};

export default PolarAreaChart;
